import apiUrls from './config/api-urls';
import HttpClient from '@mooveguru/js-http-client';

export default class Service {
	constructor() {
		this.headers = new Headers({
			'Content-Type': 'application/json',
		});
		this.googleApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
		this.httpClient = new HttpClient();
	}

	async createValuation(address, agentId) {
		const response = await this.httpClient.post(
			apiUrls.valuation.request.replace(':agentId', agentId),
			this.headers,
			{
				address: {
					city: address.city,
					country: address.country,
					postal_code: address.postalCode,
					state: address.state,
					street_address_1: address.streetAddress1,
					street_address_2: address.streetAddress2 ?? null,
				},
			}
		);

		if (!response.isOk) {
			throw new Error(response.body.message);
		}

		return response.body;
	}

	async getPropertyDetails(address) {
		const params = new URLSearchParams({
			address: JSON.stringify(address),
		});

		const response = await this.httpClient.get(
			`${apiUrls.properties}/?${params.toString()}`
		);

		if (!response.isOk) {
			throw new Error(response.body.message);
		}

		return response.body;
	}

	async getAgentById(agentId) {
		const response = await this.httpClient.get(`${apiUrls.agent}/${agentId}`);

		if (!response.isOk) {
			throw new Error(response.body.message);
		}

		return response.body;
	}

	async getThemeBySlug(slug) {
		const response = await this.httpClient.get(`${apiUrls.themes}/${slug}`);

		if (!response.isOk) {
			throw new Error(response.body.message);
		}
		return {
			...response.body.results,
			appTitle: response.body.results.title ?? null,
		};
	}

	async createContact(values, agentId, valuationId, groupId, type) {
		const response = await this.httpClient.post(
			apiUrls.valuation.contact.replace(':agentId', agentId),
			this.headers,
			{
				address: {
					city: values.address.city,
					country: values.address.country,
					postal_code: values.address.postalCode,
					state: values.address.state,
					street_address_1: values.address.streetAddress1,
					street_address_2: values.address.streetAddress2 ?? null,
				},
				email_address: values.emailAddress,
				group_id: groupId ?? null,
				name: values.name
					? {
							first: values.name.first ?? null,
							last: values.name.last ?? null,
					  }
					: null,
				phone_numbers: values?.phoneNumber
					? [
							{
								is_primary: true,
								type: 'mobile',
								value: values.phoneNumber,
							},
					  ]
					: null,
				message: values.message ?? null,
				source: 'Valuation widget',
				valuation_id: valuationId,
				valuation_type: type,
			}
		);

		if (!response.isOk) {
			throw new Error(response.body.message);
		}

		return response.body;
	}

	async getCoordinates(encodedAddress) {
		const response = await this.httpClient.get(
			`https://maps.googleapis.com/maps/api/geocode/json?address=${encodedAddress}&key=${this.googleApiKey}`
		);

		if (!response.isOk) {
			throw new Error(response.body.message);
		}

		const result = response.body.results[0];

		return result.geometry.location;
	}
}
